import { SlotAnimationConstant, SlotConstantsBehavior } from "@quest/murka-games-behavior-panther/dist";
import { IObject } from "@quest/adapter-interface";

export const gameConstants: IObject = {
  GAME_CONTAINER_DIV: "gameContainer",
  lineLayout: [
    [1, 2, 3, 4, 5],
    [6, 7, 8, 9, 10],
    [11, 12, 13, 14, 15],
    [16, 17, 18, 19, 20],
    [1, 2, 8, 4, 5],
    [6, 7, 13, 9, 10],
    [11, 12, 18, 14, 15],
    [6, 7, 3, 9, 10],
    [11, 12, 8, 14, 15],
    [16, 17, 13, 19, 20],
    [1, 7, 13, 9, 5],
    [6, 12, 18, 14, 10],
    [16, 12, 8, 14, 20],
    [11, 7, 3, 9, 15],
    [1, 7, 3, 9, 5],
    [6, 12, 8, 14, 10],
    [11, 17, 13, 19, 15],
    [16, 12, 18, 14, 20],
    [11, 7, 13, 9, 15],
    [6, 2, 8, 4, 10],
    [1, 2, 8, 14, 15],
    [6, 7, 13, 19, 20],
    [11, 12, 8, 4, 5],
    [16, 17, 13, 9, 10],
    [1, 7, 3, 9, 15],
    [6, 12, 8, 14, 20],
    [16, 12, 18, 14, 10],
    [11, 7, 13, 9, 5],
    [11, 7, 3, 9, 5],
    [16, 12, 8, 14, 10],
    [6, 12, 18, 14, 20],
    [1, 7, 13, 9, 15],
    [1, 2, 3, 9, 10],
    [6, 7, 8, 14, 15],
    [11, 12, 13, 19, 20],
    [16, 17, 18, 14, 15],
    [11, 12, 13, 9, 10],
    [6, 7, 8, 4, 5],
    [1, 7, 13, 19, 15],
    [16, 12, 8, 4, 10],
    [6, 2, 8, 14, 20],
    [11, 17, 13, 9, 5],
    [1, 2, 8, 14, 20],
    [16, 17, 13, 9, 5],
    [1, 7, 13, 19, 20],
    [16, 12, 8, 4, 5],
    [6, 2, 3, 4, 10],
    [11, 7, 8, 9, 15],
    [16, 12, 13, 14, 20],
    [11, 17, 18, 19, 15],
    [6, 12, 13, 14, 10],
    [1, 7, 8, 9, 5],
    [1, 2, 8, 4, 10],
    [6, 7, 13, 9, 15],
    [11, 12, 18, 14, 20],
    [16, 17, 13, 19, 15],
    [11, 12, 8, 14, 10],
    [6, 7, 3, 9, 5],
    [6, 2, 8, 14, 10],
    [11, 17, 13, 9, 15],
    [1, 7, 18, 9, 5],
    [16, 12, 3, 14, 20],
    [1, 17, 3, 19, 5],
    [16, 2, 18, 4, 20],
    [16, 7, 18, 9, 20],
    [1, 12, 3, 14, 5],
    [6, 2, 13, 4, 10],
    [11, 17, 8, 19, 15],
    [6, 2, 18, 4, 10],
    [11, 17, 3, 19, 15],
    [1, 2, 13, 4, 5],
    [6, 7, 18, 9, 10],
    [16, 17, 8, 19, 20],
    [11, 12, 3, 14, 15],
    [1, 2, 18, 4, 5],
    [16, 17, 3, 19, 20],
    [1, 2, 3, 4, 10],
    [6, 7, 8, 9, 5],
    [16, 17, 18, 19, 15],
    [11, 12, 13, 14, 20],
  ],
  MAN_AND_LADY_STACK_DATA: [
    [8, 3, 14],
    [9, 3, 15],
  ],
  MAN_SYMBOL_1X3_STACK_ID: 14,
  MAN_SYMBOL_ID: 8,
  LADY_SYMBOL_1X3_STACK_ID: 15,
  LADY_SYMBOL_ID: 9,
  TRANSPARENT_SYMBOL_ID: 16,

  MYSTERY_SYMBOL_NUMBER: 77,
  OFFSET_INCREMENT_X5: 5,

  // Cascade Reels Constants
  HIDE_SYMBOLS_ON_BURST_ANIMATION_PLAY: "hide_Symbols_On_Burst_Animation_Play",

  START_REEL_DROP_ON_BURST_ANIMATION_PLAY: "Start_Reel_Drop_On_Burst_Animation_Play",
  CASCADE_REEL_CONTAINER_ID: "reelContainer0",
  ANIMATION_STRING_ID: "animation",
  CASCADE_SPINE_STRING_ID: "cascade_effect",
  FG_BIG_WIN_BG_SMOKE: "big_win_in_bg_smoke_desktop",
  FG_BIG_WIN_BG_SMOKE_LOOP: "big_win_loop_bg_smoke_desktop",

  REEL_DROP_TWEEN_DURATION: 300,
  REEL_DROP_TWEEN_DELAY: 200,

  RETRIGGER_PLUS: "+",

  STOP_CASCADE_BOUNCE: 35,
  STOP_CASCADE_BOUNCE_TIME: 300,
  STOP_CASCADE_BOUNCE_TIMEOUT: 300,

  INTRO_TEXT_ANGLE: -9,
  FG_TICKUP_START_COUNT: 0,
  OUTRO_AMOUNT_ANGLE: -9.3,

  BG_CASCADING_CONTAINERX: 220,
  FG_CASCADING_CONTAINERX: 150,

  REEL_POSITION_OFFSET: 5,

  //TIMERS
  TIMER_100: 100,
  TIMER_200: 200,
  TIMER_300: 300,
  TIMER_400: 400,
  TIMER_500: 500,
  TIMER_700: 700,
  TIMER_800: 800,
  TIMER_1000: 1000,
  TIMER_1100: 1100,
  TIMER_2000: 2000,

  RESPIN_TRIGGER_SYM: 13,
  BAIT_RED_ID: 11,
  BAIT_GREEN_ID: 12,
  BAIT_REVEAL_THRESHOLD: 6,
  DELAY_FOR_NEXT_LINE_TOGGLE_TIME: 2500,
  BLUE_WIN_FRAME_SYMBOL_ID: [1, 3, 5, 7],
  BLUE_WIN_FRAME_TINT_COLOR: 0xb9eefd,
  RED_WIN_FRAME_TINT_COLOR: 0xfdaf3b,

  FIRST_SYMBOL_Y: 500,

  NEXT_LINE_TOGGLE: "delayForLineToggle",
  // WIN FRAME SPINE IDS
  WIN_FRAME: "winframe",
  WINFRAME_VERTICAL: "winframe_vertical",
  WINFRAME_HORIZONTAL: "winframe_horizontal",

  PLAYER_MESSAGE_SYMBOL_STRING: "playerMessageSymbol_",

  //REVEAL SYMBOL
  revealReelContainer: "revealReelContainer_",
  chestReelContainer: "chestReelContainer_",
  REVEAL_LAYERED_SYMBOL_ID: "revealSymbol",
  CHEST_LAYERED_SYMBOL_ID: "chestSymbol",

  //Bait Symbol
  SYMBOL_SWAP_DELAY: "SYMBOL_SWAP_DELAY",

  //FISHING TIME FEATURE
  FISH_TIME_IDLE_SPINE: "FISH_TIME_IDLE_SPINE",
  FISH_TIME_INTRO_BLURBG_SHOW: "FISH_TIME_INTRO_BLURBG_SHOW",
  FISH_TIME_OUTRO_BLURBG_SHOW: "FISH_TIME_OUTRO_BLURBG_SHOW",
  JACKPOT_BLUR_BG: "JackpotBlurImage",

  //Collection Screen
  COLLECTION_BG: "COLLECTION_BG",
  COLLECTION_MASKIDS: ["fillerMask_151_", "fillerMask_152_"],
  COLLECTION_PROGRESS_IDS: ["progress_151_", "progress_152_"],
  COLLECTION_COUNT_IDS: ["count_151_", "count_152_"],
  COLLECTION_BGGLOW_IDS: ["bgGlow_151_","bgGlow_152_"],
  COLLECTION_GLOW_IDS: ["glow_151_", "glow_152_"],
  COLLECTION_FISH_ID: "fish_",
  COLLECTION_BUTTONS_ENABLE: "COLLECTION_BUTTONS_ENABLE",
  COLLECTION_BUTTONS_DISABLE: "COLLECTION_BUTTONS_DISABLE",
  COLLECTION_IDS: [4, 6, 9, 12, 16, 20],
  
  COLLECTION_PAIRS : {
    "newbie": [4,6],
    "exp": [9, 12],
    "master": [16, 20]
  },
  COLLECTION_LEVELS_SERVER_ID: ["newbie_collection",
    "experienced_collection",
    "master_collection"
  ],
  COLLECTION_LEVELS_GAME: ["newbie",
    "exp",
    "master"
  ],

  //HnR feature
  STOP_RESPIN_BOUNCE: 10,
  STOP_RESPIN_BOUNCE_TIME: 150,
  STOP_RESPIN_BOUNCE_TIMEOUT: 150,
  GREEN_COLLECTION_ID: 152,
  RED_COLLECTION_ID: 151,

  //HnR Counter
  GLOW_ANIM_Y: [116, 68, 20],

  //Portrait
  PORTRAIT_SHIFT_X: -40,
  // autobait
  BAIT_MOVE_TIME:1100,
  BAIT_MOVE_SCALE_TIME:550,

};
SlotConstantsBehavior.FONT_LIST = [
  "Arial",
  "ArialBlack",
  "MinionPro-Bold",
  "ArialBold",
  "ALBERTUS-EXTRA-BOLD-REGULAR-1",
  "AGFRIQUER BOLD",
  "AlbertusNova-Regular",
  "Albertus-Nova-W07-Bold",
];
SlotConstantsBehavior.FREEGAME_IDLE_SPINE_ID = "freegame_idle";
SlotConstantsBehavior.FREEGAME_IDLE_SPINE = "freegame_desktop_idle";
SlotConstantsBehavior.SCATTER_SYM_NUM = 13;
SlotConstantsBehavior.BASEGAME_IDLE_SPINE = "desktop_idle_desktop";
SlotAnimationConstant.BG_BIG_WIN_START = "big_win_in_characters";
SlotAnimationConstant.BG_BIG_WIN_LOOP = "big_win_loop_characters";
SlotAnimationConstant.BG_BIG_WIN_BACKGROUND_START = "big_win_desktop_in_bg";
SlotAnimationConstant.BG_BIG_WIN_BACKGROUND_LOOP = "big_win_desktop_loop_bg";
SlotAnimationConstant.FG_INTRO_DESKTOP_BG_IN = "freespins_intro_in_bg_desktop";
SlotAnimationConstant.FG_INTRO_DESKTOP_IN = "freespins_intro_in_fg";
SlotAnimationConstant.FG_INTRO_DESKTOP_BG_STATIC = "freespins_intro_loop_bg_desktop";
SlotAnimationConstant.FG_INTRO_DESKTOP_BG_OUT = "freespins_intro_out_bg_desktop";
SlotAnimationConstant.FG_INTRO_DESKTOP_OUT = "freespins_intro_out_fg";
SlotAnimationConstant.FG_INTRO_DESKTOP_STATIC = "freespins_intro_loop_fg";
SlotAnimationConstant.FG_OUTRO_DESKTOP_BG_IN = "freespins_outro_in_bg_desktop";
SlotAnimationConstant.FG_OUTRO_DESKTOP_BG_LOOP = "freespins_outro_loop_bg_desktop";
SlotAnimationConstant.FG_OUTRO_DESKTOP_OUT = "freespins_outro_out_fg";
SlotAnimationConstant.FG_OUTRO_DESKTOP_OUT_BG = "freespins_outro_out_bg_desktop";
SlotAnimationConstant.FG_OUTRO_DESKTOP_LOOP = "freespins_outro_loop_fg";
SlotAnimationConstant.FG_OUTRO_DESKTOP_IN = "freespins_outro_in_fg";

SlotAnimationConstant.FG_BIG_WIN_DESKTOP_START = "big_win_in_characters";
SlotAnimationConstant.FG_BIG_WIN_DESKTOP_LOOP = "big_win_loop_characters";
SlotAnimationConstant.FG_BIG_WIN_DESKTOP = "freegame_bigwin";

SlotAnimationConstant.FG_INTRO_PORTRAIT_BG_IN = "freespins_intro_in_bg_portrait";
SlotAnimationConstant.FG_INTRO_PORTRAIT_BG_STATIC = "freespins_intro_loop_bg_portrait";
SlotAnimationConstant.FG_INTRO_PORTRAIT_BG_OUT = "freespins_intro_out_bg_portrait";
SlotAnimationConstant.FG_OUTRO_PORTRAIT_BG_IN = "freespins_outro_in_bg_portrait";
SlotAnimationConstant.FG_OUTRO_PORTRAIT_BG_LOOP = "freespins_outro_loop_bg_portrait";
SlotAnimationConstant.FG_OUTRO_PORTRAIT_BG_OUT = "freespins_outro_out_bg_portrait";

SlotAnimationConstant.FG_INTRO_PORTRAIT_IN = "freespins_intro_in_fg";
SlotAnimationConstant.FG_INTRO_PORTRAIT_STATIC = "freespins_intro_loop_fg";
SlotAnimationConstant.FG_INTRO_PORTRAIT_OUT = "freespins_intro_out_fg";
SlotAnimationConstant.FG_OUTRO_PORTRAIT_IN = "freespins_outro_in_fg";
SlotAnimationConstant.FG_OUTRO_PORTRAIT_LOOP = "freespins_outro_loop_fg";
SlotAnimationConstant.FG_OUTRO_PORTRAIT_OUT = "freespins_outro_out_fg";

SlotAnimationConstant.FG_BIG_WIN_PORTRAIT_START = "big_win_in_bg_smoke_portrait";
SlotAnimationConstant.FG_BIG_WIN_PORTRAIT_LOOP = "big_win_loop_bg_smoke_portrait";
SlotAnimationConstant.BG_BIG_WIN_CHAR_START_PORT = "big_win_in_characters";
SlotAnimationConstant.BG_BIG_WIN_CHAR_LOOP_PORT = "big_win_loop_characters"
SlotAnimationConstant.BG_BIG_WIN_BACKGROUND_START_POTRAIT = "big_win_portrait_in_bg";
SlotAnimationConstant.BG_BIG_WIN_BACKGROUND_LOOP_POTRAIT = "big_win_portrait_loop_bg";

SlotConstantsBehavior.REEL_BOTTOM_SPACE_LANDSCAPE = -30;